import { render, staticRenderFns } from "./criticalillness.vue?vue&type=template&id=1aa37a08&scoped=true&"
import script from "./criticalillness.vue?vue&type=script&lang=js&"
export * from "./criticalillness.vue?vue&type=script&lang=js&"
import style0 from "./criticalillness.vue?vue&type=style&index=0&id=1aa37a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa37a08",
  null
  
)

export default component.exports